var map = {
	"./android.svg": 2205,
	"./atv.svg": 7803,
	"./chrome.svg": 942,
	"./chromecast.svg": 7419,
	"./cloudsync.svg": 7634,
	"./default.svg": 111,
	"./dlna.svg": 3011,
	"./firefox.svg": 9803,
	"./gtv.svg": 5509,
	"./ie.svg": 4318,
	"./ios.svg": 2815,
	"./kodi.svg": 3963,
	"./linux.svg": 8186,
	"./macos.svg": 7015,
	"./msedge.svg": 5843,
	"./opera.svg": 8205,
	"./playstation.svg": 7730,
	"./plex.svg": 4419,
	"./plexamp.svg": 5639,
	"./roku.svg": 7877,
	"./safari.svg": 2296,
	"./samsung.svg": 8952,
	"./synclounge.svg": 6707,
	"./tivo.svg": 4244,
	"./wiiu.svg": 8922,
	"./windows.svg": 5743,
	"./xbox.svg": 1763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2120;